import React, { useState } from "react";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Button, TablePagination } from "@material-ui/core";
import styles from "../../Style.module.css";
import { useSelector } from "react-redux";

const EmployeeCards = ({
  data,
  isGroupAdmin,
  toggleExitDialog,
  coAdminIds,
  isAdminCoAdmin,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const {
    user: { id: emp_id },
  } = useSelector((state) => state.auth);

  const employees = data?.employees || [];
  const totalCount = employees.length;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage + 1);
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentEmployees = employees.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  return (
    <div>
      <div className={styles.cardContainer}>
        {currentEmployees.map((val) => (
          <div key={val?.id} className={styles.cardWrap}>
            <div className={styles.cardCont}>
              <img src={val?.image} className={styles.img} />
              <div className={styles.cardDes}>
                <strong>{val?.name}</strong>
                <div>{val?.code}</div>
              </div>
            </div>
            <div className={styles.coCont}>
              <div className={styles.coWrap}>
                {coAdminIds?.includes(val?.id) && <div>Co-Admin</div>}
              </div>
              {val?.is_admin ? (
                <div className={styles.adminText}>Admin</div>
              ) : isGroupAdmin || isAdminCoAdmin ? (
                <>
                  {emp_id !== val?.id && (
                    <Button
                      // disabled={!isGroupAdmin || !isAdminCoAdmin}
                      onClick={() => toggleExitDialog(val)}
                    >
                      <ExitToAppIcon style={{ fontSize: "medium" }} />
                    </Button>
                  )}
                </>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={currentPage - 1}
        onPageChange={(event, newPage) => handlePageChange(newPage)}
        className={styles.paginationClass}
      />
    </div>
  );
};

export default EmployeeCards;
